import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "removeTrailingZeros",
    pure: true,
    standalone: false
})
export class RemoveTrailingZerosPipe implements PipeTransform {
  transform(value: string): string | null {
    // Convert the number to a string to manipulate it
    const stringValue = value.toString();

    // Split the string by the decimal point
    const parts = stringValue.split(".");

    if (parts.length === 2) {
      // If there is a decimal part, remove trailing zeros from it
      const decimalPart = parts[1].replace(/0+$/, "");

      // If there is a remaining decimal part, join it back with the integer part
      if (decimalPart.length > 0) {
        return parts[0] + "." + decimalPart;
      }
    }

    // If there's no decimal part or it's empty after removing trailing zeros, return the integer part only
    return parts[0];
  }
}
